import UAParser from 'ua-parser-js';

const BLANKSTRING = '';
const browserTypes = {
  CHROME: 'Chrome',
  SAFARI: 'Safari',
  FIREFOX: 'Firefox',
  IE: 'IE',
  EDGE: 'Edge',
  ChromeWebView: 'Chrome WebView',
  MobileSafari: 'Mobile Safari',
  Opera: 'Opera',
  SamsungBrowser: 'Samsung Browser',
  OperaMobi: 'Opera Mobi'
};

/**
 * Method that finds out the browser's and operating system's details.
 * Works at both client and server side.
 * @param {String} userAgent The user agent of the current browser
 * @returns {Object} browser's and operating system's name and version,deviceType
 */
export const getBrowserInfo = (userAgent) => {
  const parser = new UAParser(userAgent);
  const {
    name: browserName = BLANKSTRING,
    version: browserFullVersion = BLANKSTRING
  } = parser.getBrowser();
  const {
    name: osName = BLANKSTRING,
    version: osVersion = BLANKSTRING
  } = parser.getOS();
  const browserMajorVersion = +browserFullVersion.split('.', 1);
  return {
    browserName,
    browserFullVersion,
    browserMajorVersion,
    osName,
    osVersion,
    deviceType: parser.getDevice()?.type
  };
};
/**
 * Method to detect if the user agent is that if a crawler or a bot
 * @param {String} userAgent user agent string
 * @returns {Boolean} is it a bot
 */
export const isBot = (userAgent) =>
  /googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis/i.test(
    userAgent
  );

/**
 * Method that validates current browser according to its version number
 * @param {Object} browserDetails Browser details
 * @returns {Boolean} is a valid browser
 */
export const isValidBrowser = (userAgent) => {
  const { browserName, browserMajorVersion } = getBrowserInfo(userAgent);
  switch (browserName) {
    case browserTypes.CHROME:
      return browserMajorVersion >= 49;
    case browserTypes.FIREFOX:
      return browserMajorVersion >= 31;
    case browserTypes.SAFARI:
      return browserMajorVersion >= 9.1;
    case browserTypes.EDGE:
      return browserMajorVersion >= 49;
    case browserTypes.IE:
      return false;
    case browserTypes.MobileSafari:
      return browserMajorVersion >= 9.3;
    case browserTypes.Opera:
      return browserMajorVersion >= 36;
    case browserTypes.SamsungBrowser:
      return browserMajorVersion >= 5;
    case browserTypes.OperaMobi:
      return browserMajorVersion > 36;
    default:
      return true;
  }
};
